import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { expandPlugin as legacyExpandPlugin } from './legacyExpand/plugin';
import { expandPlugin as singlePlayerExpandPlugin } from './singlePlayerExpand/plugin';
export var expandPlugin = function expandPlugin(_ref) {
  var _ref$config = _ref.config,
    options = _ref$config === void 0 ? {} : _ref$config,
    api = _ref.api;
  if (options !== null && options !== void 0 && options.__livePage) {
    return singlePlayerExpandPlugin({
      config: options,
      api: api
    });
  } else {
    if (getBooleanFF('platform.editor.single-player-expand')) {
      return singlePlayerExpandPlugin({
        config: options,
        api: api
      });
    } else {
      return legacyExpandPlugin({
        config: options,
        api: api
      });
    }
  }
};